import React from 'react'

const Logo = () => {
  return (
    <>
     <a href='/'><img src='/images/logo.svg' width='100%' alt="shivalik-logo" /></a>
    </>
  )
}

export default Logo
